import type { DeleteRecordActionConfig, OpenPageActionConfig } from '@lighthouse/core'
import type {
    AliyunMessageActionConfig,
    BatchImportFileActionConfig,
    CallActionConfig,
    ClickTriggerConfig,
    CopyActionConfig,
    CreateRecordActionConfigure as CreateRecordActionNode,
    CreateRecordTriggerConfig,
    CreateSingleRecordActionConfigure as CreateSingleRecordActionNode,
    DownloadFileActionConfig,
    EndConfig,
    FindRecordActionConfigure as FindRecordActionNode,
    FindSingleRecordActionConfigure as FindSingleRecordActionNode,
    FlowNode,
    HandleSubProcessActionConfigure as HandleSubProcessActionNode,
    ImportExcelActionConfig,
    LLMActionConfig,
    LoopNodeActionConfig,
    MatchConditionTriggerConfig,
    NodeTypes,
    NotificationActionConfig,
    OpenLinkActionConfig,
    OpenWeChatCustomerServiceActionConfig,
    ParamExtractionActionConfigure as ParamExtractionActionNode,
    RunCodeActionConfig,
    ScheduledTriggerConfig,
    SearchApiActionConfig,
    SendEmailActionConfig,
    SendMsgDingTalkRobotConfig,
    SendMsgWxRootConfig,
    SendWebSocketActionConfig,
    StationMessageActionConfig,
    StripeActionConfig,
    UpdateRecordActionConfigure as UpdateRecordActionNode,
    UpdateRecordTriggerConfig,
    VariableTriggerConfig,
    WebhookTriggerConfig,
    WebsocketTriggerConfig,
    WeChatAddProfitSharingReceiverActionConfig,
    WeChatDeleteProfitSharingReceiverActionConfig,
    WechatFollowWaybillActionConfig,
    WechatGenerateMiniProgramCodeActionConfig,
    WechatGetOrderListActionConfig,
    WechatGetOrderShippingActionConfig,
    WechatNavigateToMiniProgramActionConfig,
    WechatOpenAudioPlayerActionConfig,
    WechatOpenChannelsActivityActionConfig,
    WechatOpenLocationActionConfig,
    WeChatPayActionConfig,
    WeChatProfitSharingActionConfig,
    WeChatProfitSharingQueryActionConfig,
    WeChatProfitSharingQueryAmountActionConfig,
    WeChatRefundActionConfig,
    WeChatRefundQueryActionConfig,
    WechatSubscriptionMessageConfig,
    WechatSubscriptionMessageNotificationsConfig,
    WechatTemplateMsgActionConfig,
    WechatUploadShippingInfoActionConfig
} from '@lighthouse/shared'
import React, { useCallback, useMemo } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'

import { AliyunMessageActionConfigure } from './Actions/AliyunMessageActionConfigure'
import { BaiduSearchActionConfigure } from './Actions/BaiduSearchActionConfigure'
import { BatchImportFileActionConfigure } from './Actions/BatchImportFileActionConfigure'
import { BingSearchActionConfigure } from './Actions/BingSearchActionConfigure'
import { CallActionConfigure } from './Actions/CallActionConfigure'
import { CloseFloatActionConfigure } from './Actions/CloseFloatActionConfigure'
import { CodeExecuteActionConfigure } from './Actions/CodeExecuteActionConfigure'
import { CopyActionConfigure } from './Actions/CopyActionConfigure'
import { CreateRecordActionConfigure } from './Actions/CreateRecordActionConfigure'
import { CreateSingleRecordActionConfigure } from './Actions/CreateSingleRecordActionConfigure'
import { DeleteRecordActionConfigure } from './Actions/DeleteRecordActionConfigure'
import { DingTalkRobotActionConfigure } from './Actions/DingTalkRobotActionConfigure'
import { DownloadFileActionConfigure } from './Actions/DownloadFileActionConfigure'
import { FindRecordActionConfigure } from './Actions/FindRecordActionConfigure'
import { FindSingleRecordActionConfigure } from './Actions/FindSingleRecordActionConfigure'
import { GoBackActionConfigure } from './Actions/GoBackActionConfigure'
import { GoogleSearchActionConfigure } from './Actions/GoogleSearchActionConfigure'
import { HandleSubProcessActionConfigure } from './Actions/HandleSubProcessActionConfigure'
import { ImportExcelActionConfigure } from './Actions/ImportExcelActionConfigure'
import { LLMActionConfigure } from './Actions/LLMActionConfigure'
import { LoopNodeActionConfigure } from './Actions/LoopNodeActionConfigure'
import { NotificationActionConfigure } from './Actions/NotificationActionConfigure'
import { OpenLinkActionConfigure } from './Actions/OpenLinkActionConfigure'
import { OpenPageActionConfigure } from './Actions/OpenPageActionConfigure'
import { ParameterExtractActionConfigure } from './Actions/ParameterExtractActionConfigure'
import { RefreshPageActionConfigureConfigure } from './Actions/RefreshPageActionConfigure'
import { RefreshUserPermissionsActionConfigure } from './Actions/RefreshUserPermissionsActionConfigure'
import { SendEmailActionConfigure } from './Actions/SendEmailActionConfigure'
import { SendWebSocketActionConfigure } from './Actions/SendWebSocketActionConfigure'
import { StationMessageActionConfigure } from './Actions/StationMessageActionConfigure'
import { StripeActionConfigure } from './Actions/StripeActionConfigure'
import { UpdateRecordActionConfigure } from './Actions/UpdateRecordActionConfigure'
import { WeChatAddProfitSharingReceiverActionConfigure } from './Actions/WeChatAddProfitSharingReceiverActionConfigure'
import { OpenWeChatCustomerServiceActionConfigure } from './Actions/WeChatCustomerServiceActionConfigure'
import { WeChatDeleteProfitSharingReceiverActionConfigure } from './Actions/WeChatDeleteProfitSharingReceiverActionConfigure'
import { WechatFollowWaybillActionConfigure } from './Actions/WechatFollowWaybillActionConfigure'
import { WechatGenerateMiniProgramCodeActionConfigure } from './Actions/WechatGenerateMiniProgramCodeActionConfigure'
import { WechatGetOrderListActionConfigure } from './Actions/WechatGetOrderListActionConfigure'
import { WechatGetOrderShippingActionConfigure } from './Actions/WechatGetOrderShippingActionConfigure'
import { WechatNavigateToMiniProgramActionConfigure } from './Actions/WechatNavigateToMiniProgramActionConfigure'
import { WechatOpenAudioPlayerActionConfigure } from './Actions/WechatOpenAudioPlayerActionConfigure'
import { WechatOpenChannelsActivityActionConfigure } from './Actions/WechatOpenChannelsActivityActionConfigure'
import { WechatOpenLocationActionConfigure } from './Actions/WechatOpenLocationActionConfigure'
import { WeChatPayActionConfigure } from './Actions/WeChatPayActionConfigure'
import { WeChatProfitSharingActionConfigure } from './Actions/WeChatProfitSharingActionConfigure'
import { WeChatProfitSharingQueryActionConfigure } from './Actions/WeChatProfitSharingQueryActionConfigure'
import { WeChatProfitSharingQueryAmountActionConfigure } from './Actions/WeChatProfitSharingQueryAmountActionConfigure'
import { WeChatRefundActionConfigure } from './Actions/WeChatRefundActionConfigure'
import { WeChatRefundQueryActionConfigure } from './Actions/WeChatRefundQueryActionConfigure'
import { WechatUploadShippingInfoActionConfigure } from './Actions/WechatUploadShippingInfoActionConfigure'
import { WxRobotActionConfigure } from './Actions/WxRobotActionConfigure'
import { WxSubscriptionActionConfigure } from './Actions/WxSubscriptionActionConfigure'
import { WxSubscriptionNotificationActionConfigure } from './Actions/WxSubscriptionNotificationActionConfigure'
import { WxTemplateActionConfigure } from './Actions/WxTemplateActionConfigure'
import { ConditionConfigure } from './ConditionConfigure'
import { EndConfigure } from './End/EndConfigure'
import { ArgConfigure } from './Triggers/ArgConfigure'
import { ClickTriggerConfigure } from './Triggers/ClickTriggerConfigure'
import { CreateRecordTriggerConfigure } from './Triggers/CreateRecordTriggerConfigure'
import { EmptyTriggerConfigure } from './Triggers/EmptyTriggerConfigure'
import { MatchConditionTriggerConfigure } from './Triggers/MatchConditionTriggerConfigure'
import { ScheduledTriggerConfigure } from './Triggers/ScheduledTriggerConfigure'
import { UpdateRecordTriggerConfigure } from './Triggers/UpdateRecordTriggerConfigure'
import { WebhookTriggerConfigure } from './Triggers/WebhookTriggerConfigure'
import { WebsocketTriggerConfigure } from './Triggers/WebsocketTriggerConfigure'

const SCxContainer = styled.div`
    padding-bottom: 100px;
`
interface NodeSettingProps {
    allParentNodes: FlowNode[]
    nodeType?: NodeTypes
}

export const NodeSetting: React.FC<NodeSettingProps> = ({ allParentNodes, nodeType }) => {
    const { control, setValue } = useFormContext()
    const nodeName = useWatch({ control, name: 'name' }) as string

    const setNodeType = useCallback((val: NodeTypes) => setValue('nodeType', val), [setValue])
    const setName = useCallback((val: string) => setValue('name', val), [setValue])

    const nodeSettingContent = useMemo(() => {
        if (!nodeType) {
            return null
        }

        switch (nodeType) {
            /** 自动化开始节点 */
            case 'EMPTY_TRIGGER': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <EmptyTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            /** 自动化触发 */
            case 'CREATE_RECORD_TRIGGER': {
                // 当记录被创建时
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <CreateRecordTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as CreateRecordTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'UPDATE_RECORD_TRIGGER': {
                // 当记录被更新时
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <UpdateRecordTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as UpdateRecordTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'MATCH_CONDITION_TRIGGER': {
                // 当记录满足条件时
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <MatchConditionTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                allParentNodes={allParentNodes}
                                value={field.value as MatchConditionTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'SCHEDULED_TRIGGER': {
                // 定时触发
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <ScheduledTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as ScheduledTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            /** 动作流触发 */
            case 'CLICK_TRIGGER': {
                // 当点击时
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <ClickTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as ClickTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WEBSOCKET_TRIGGER': {
                // 接受通知时
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WebsocketTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as WebsocketTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            /** 子流程触发 */
            case 'ARG_TRIGGER': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <ArgConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as VariableTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WEBHOOK_TRIGGER': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WebhookTriggerConfigure
                                nodeType={nodeType}
                                onNodeTypeChange={setNodeType}
                                onNodeNameChange={setName}
                                value={field.value as WebhookTriggerConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            /** 行为节点 */
            case 'CREATE_SINGLE_RECORD_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <CreateSingleRecordActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as CreateSingleRecordActionNode['config']}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'CREATE_RECORD_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <CreateRecordActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as CreateRecordActionNode['config']}
                                onChange={val => {
                                    field.onChange(val)
                                }}
                            />
                        )}
                    />
                )
            }
            case 'UPDATE_RECORD_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <UpdateRecordActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as UpdateRecordActionNode['config']}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'FIND_SINGLE_RECORD_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <FindSingleRecordActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as FindSingleRecordActionNode['config']}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'FIND_RECORD_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <FindRecordActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as FindRecordActionNode['config']}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WX_ROBOT_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WxRobotActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SendMsgWxRootConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'DINGTALK_ROBOT_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <DingTalkRobotActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SendMsgDingTalkRobotConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'CONDITION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <ConditionConfigure allParentNodes={allParentNodes} value={field.value} onChange={field.onChange} />
                        )}
                    />
                )
            }
            case 'LOOP_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <LoopNodeActionConfigure
                                nodeType={nodeType}
                                nodeName={nodeName}
                                allParentNodes={allParentNodes}
                                value={field.value as LoopNodeActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            // case 'MANUALLY_TRIGGER': {
            //     break
            // }
            /** 动作流独有动作 */
            case 'OPEN_PAGE': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <OpenPageActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as OpenPageActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'OPEN_LINK': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <OpenLinkActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as OpenLinkActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'GO_BACK': {
                return <GoBackActionConfigure nodeType={nodeType} />
            }
            case 'NOTIFICATION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <NotificationActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as NotificationActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'COPY': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <CopyActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as CopyActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'CALL': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <CallActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as CallActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'DELETE_RECORD': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <DeleteRecordActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as DeleteRecordActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'IMPORT_EXCEL': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <ImportExcelActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as ImportExcelActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'BATCH_IMPORT_FILE': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <BatchImportFileActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as BatchImportFileActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'SEND_EMAIL_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <SendEmailActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SendEmailActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'STATION_MESSAGE_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <StationMessageActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as StationMessageActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'DOWNLOAD_FILE': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <DownloadFileActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as DownloadFileActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'ALIYUN_MESSAGE_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <AliyunMessageActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as AliyunMessageActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_PAY': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatPayActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatPayActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_REFUND': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatRefundActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatRefundActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_REFUND_QUERY': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatRefundQueryActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatRefundQueryActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_PROFIT_SHARING': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatProfitSharingActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatProfitSharingActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_PROFIT_SHARING_QUERY': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatProfitSharingQueryActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatProfitSharingQueryActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_PROFIT_SHARING_QUERY_AMOUNT': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatProfitSharingQueryAmountActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatProfitSharingQueryAmountActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_ADD_RECEIVER': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatAddProfitSharingReceiverActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatAddProfitSharingReceiverActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'OPEN_WECHAT_CUSTOMER_SERVICE': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <OpenWeChatCustomerServiceActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as OpenWeChatCustomerServiceActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_DELETE_RECEIVER': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WeChatDeleteProfitSharingReceiverActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WeChatDeleteProfitSharingReceiverActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_TEMPLATE_MSG_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WxTemplateActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatTemplateMsgActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_SUBSCRIPTION_MSG_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WxSubscriptionActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatSubscriptionMessageConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_SUBSCRIPTION_MSG_NOTIFICATION_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WxSubscriptionNotificationActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatSubscriptionMessageNotificationsConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_OPEN_LOCATION_ACTION': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatOpenLocationActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatOpenLocationActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_NAVIGATE_TO_MINI_PROGRAM': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatNavigateToMiniProgramActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatNavigateToMiniProgramActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_OPEN_CHANNELS_ACTIVITY': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatOpenChannelsActivityActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatOpenChannelsActivityActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'WECHAT_OPEN_AUDIO_PLAYER': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatOpenAudioPlayerActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatOpenAudioPlayerActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'WECHAT_GENERATE_MINIPROGRAM_CODE': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatGenerateMiniProgramCodeActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatGenerateMiniProgramCodeActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'WECHAT_UPLOAD_SHIPPING_INFO': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatUploadShippingInfoActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatUploadShippingInfoActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'WECHAT_GET_ORDER_SHIPPING': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatGetOrderShippingActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatGetOrderShippingActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'WECHAT_GET_ORDER_LIST': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatGetOrderListActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatGetOrderListActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'WECHAT_FOLLOW_WAYBILL': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <WechatFollowWaybillActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as WechatFollowWaybillActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }

            case 'STRIPE': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <StripeActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as StripeActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'REFRESH_PAGE': {
                return <RefreshPageActionConfigureConfigure nodeType={nodeType} />
            }
            case 'REFRESH_USER_PERMISSIONS': {
                return <RefreshUserPermissionsActionConfigure nodeType={nodeType} />
            }
            case 'HANDLE_SUB_PROCESS': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <HandleSubProcessActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as HandleSubProcessActionNode['config']}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'SEND_WEBSOCKET': {
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <SendWebSocketActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SendWebSocketActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'CLOSE_FLOAT': {
                return <CloseFloatActionConfigure nodeType={nodeType} />
            }
            case 'LLM_ACTION': {
                // 大语言模型 LLM
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <LLMActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as LLMActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'GOOGLE_SEARCH_ACTION': {
                // google search api
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <GoogleSearchActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SearchApiActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'BING_SEARCH_ACTION': {
                // bing search api
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <BingSearchActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SearchApiActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'BAIDU_SEARCH_ACTION': {
                // baidu search api
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <BaiduSearchActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as SearchApiActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'CODE_ACTION': {
                // 代码执行
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <CodeExecuteActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as RunCodeActionConfig}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'PARAM_EXTRACT_ACTION': {
                // 参数提取
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <ParameterExtractActionConfigure
                                nodeType={nodeType}
                                allParentNodes={allParentNodes}
                                value={field.value as ParamExtractionActionNode['config']}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            case 'END': {
                // 参数提取
                return (
                    <Controller
                        control={control}
                        name="config"
                        render={({ field }) => (
                            <EndConfigure
                                allParentNodes={allParentNodes}
                                value={field.value as EndConfig | undefined}
                                onChange={field.onChange}
                            />
                        )}
                    />
                )
            }
            default: {
                return null
            }
        }
    }, [allParentNodes, control, nodeName, nodeType, setName, setNodeType])

    return <SCxContainer>{nodeSettingContent}</SCxContainer>
}
